import { __decorate } from "tslib";
import _ from 'lodash';
import { taskCenterListApi, deleteTaskApi, deleteAllTaskApi, cancelTaskApi, undoTaskApi, getUndoTaskStatusByIdApi, } from '@cores/apis/workspace_api/task_center';
import { Toast } from 'patsnap-biz';
import { dialogConfig, undoDialogConfig } from '../constants/taskCenterConfig';
import { rvTrack } from 'track';
import { injectService, provide } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
import { TaggingService } from '@/domains/ai-tagging/services/tagging-service.interface';
import { SmartLabelStatus } from '@/domains/ai-tagging/enums';
const MAX_POLLING_STEP_TIME = 32; // 最大轮询间隔时长为32秒
const MAX_POLLING_TIME = 10 * 60; // 最多轮询10分钟
let POLLING_STEP_TIME = 1; // 初始为1秒，然后逐步增加，1，2，4，8，16，32，最大为32，后不再增加
export const TaskCenterServiceSymbol = Symbol.for('TaskCenterService');
let TaskCenterService = class TaskCenterService {
    constructor() {
        this.TASK_TYPES = ['ALL_TYPE', 'COPY_TYPE', 'MOVE_TYPE', 'LABEL_TYPE', 'LABEL_AI_TYPE', 'LABEL_RULE_TYPE', 'HIRO_AGENT_TYPE', 'WS_AUTH_TYPE', 'IMPORT_TYPE', 'UPDATE_COMMENT_VISIBLE_SCOPE'];
        this.TASK_STATUS = [
            'ALL_STATUS',
            'READY_STATUS',
            'PROGRESSING_STATUS',
            'CANCELING_STATUS',
            'CANCELED_STATUS',
            'FINISHED_STATUS',
            'FAILED_STATUS',
            // 'UNDO_FINISHED_STATUS'
        ];
        this.TASK_DETAIL_TYPES = [
            'DELETE_FOLDER',
            'DELETE_PATENT',
            'COPY_PATENT',
            'COPY_FOLDER',
            'MOVE_PATENT',
            'MOVE_FOLDER',
            'TRANSFER_COPY_SPACE',
            'BULK_EDIT', // 批量标引
            'AUTO_BULK_EDIT', // 智能关键词标引
            'FIELD_TRANSFORM_BULK_EDIT', // 自定义字段匹配
            'AUTO_LABEL_BULK_EDIT', // 规则标引
            'HIRO_AGENT_BATCH_LABEL', // Hiro Agent批量标引
            'USER_DELETE_LAYER_VALUE', // 层级字段节点调整
            'UPDATE_COMMENT_VISIBLE_SCOPE',
        ];
        this.UNDO_TASK_DETAIL_TYPES = [
            'COPY_PATENT',
            'MOVE_PATENT',
            'BULK_EDIT', // 批量标引
            'AUTO_LABEL_BULK_EDIT', // 规则标引
            'SMART_CUSTOM_FIELD', // 智能标引
            'HIRO_AGENT_BATCH_LABEL', // Hiro Agent批量标引
        ];
        this.UNDO_TASK_DETAIL_DATA_TYPES = [
            'PATENT',
        ];
        this.page = 1;
        this.goPage = 1;
        this.total = 4;
        this.limit = 50;
        this.isLoading = false;
        this.tasks = [];
        this.status = 'ALL_STATUS';
        this.type = 'ALL_TYPE';
        this.confirmType = '';
        this.confirmTask = '';
        this.confirmLoading = false;
        this.confirmDialogData = {};
        this.undoInProgress = false;
        this.undoInProgressTimeOut = false;
        this.pollingTime = 0;
        this.pollingTimes = 0;
        this.i18n = injectService(i18nSymbol);
        this.taggingService = injectService(TaggingService);
    }
    get isVaildGoPage() {
        const intGoPage = Number(this.goPage);
        const maxPage = _.ceil(this.total / this.limit);
        return intGoPage && !_.isNaN(intGoPage) && intGoPage > 0 && intGoPage <= maxPage;
    }
    get isNoTasks() {
        return _.isEmpty(this.tasks);
    }
    /**
     * 获取任务列表
     * @param {*} param
     * @param {*} param.page 页码，默认1
     * @param {*} param.limit 分页，默认10
     * @param {*} param.type 任务类型
     * @param {*} param.status 任务状态
     */
    fetchTasks({ page, limit, type, status } = {}) {
        this.isLoading = true;
        taskCenterListApi({
            page: page || this.page,
            limit: limit || this.limit,
            type: type || this.type,
            status: status || this.status,
        })
            .then(data => {
            this.page = data.page;
            this.goPage = data.page;
            this.total = data.total;
            this.limit = data.limit;
            this.tasks = data.rows;
            this.isLoading = false;
        })
            .catch(err => {
            Toast({
                dangerouslyUseHTMLString: true,
                type: 'error',
                message: err._error_msg,
                showClose: true,
            });
            this.isLoading = false;
        })
            .finally(() => {
            this.checkNeedFetchPrevious();
        });
    }
    checkNeedFetchPrevious() {
        if (this.page > 1 && _.isEmpty(this.tasks)) {
            this.fetchTasks({
                page: this.page - 1,
            });
        }
    }
    cancelTask(task_id) {
        this.confirmLoading = true;
        cancelTaskApi({ task_id })
            .then(() => {
            const task = _.find(this.tasks, t => t.task_id === task_id);
            task.task_status = 'CANCELED_STATUS';
        })
            .catch(err => {
            Toast({
                dangerouslyUseHTMLString: true,
                type: 'error',
                message: err._error_msg,
                showClose: true,
            });
        })
            .finally(() => {
            this.confirmLoading = false;
            this.confirmType = '';
        });
    }
    cancelAiTaggingTask(task) {
        const taskParams = this.getAiTaggingTaskParams(task);
        if (!taskParams) {
            Toast({
                type: 'error',
                message: this.i18n.t('commonStatusCode.400'),
                showClose: true,
            });
            this.confirmType = '';
            return;
        }
        this.confirmLoading = true;
        this.taggingService.cancelTagging(taskParams)
            .then(res => {
            task.smart_label_status = res.smart_label_status;
            task.task_schedule = res.task_schedule;
            task.task_status_code = res.task_status_code;
            if (res.smart_label_status === SmartLabelStatus.LABEL_CANCELED) {
                task.task_status = 'CANCELED_STATUS';
                Toast({
                    type: 'success',
                    message: this.i18n.t('SmartAnnotation.RESULT.loadingStep.LABEL_CANCELED'),
                    showClose: true,
                });
            }
        })
            .catch(err => {
            const errorCode = Number(err?.response?.data?.numeric_error_code ?? err?._error_code);
            if (errorCode === 110412) {
                return;
            }
            Toast({
                dangerouslyUseHTMLString: true,
                type: 'error',
                message: errorCode === 70110208
                    ? this.i18n.t('SmartAnnotation.RESULT.cancelTask.conflict')
                    : err._error_msg,
                showClose: true,
            });
        })
            .finally(() => {
            this.confirmLoading = false;
            this.confirmType = '';
        });
    }
    getAiTaggingTaskParams(task) {
        const compositeTaskId = String(task.task_id || '');
        const separatorIndex = compositeTaskId.lastIndexOf('_');
        const taskId = compositeTaskId.slice(0, separatorIndex);
        const operationTimeText = compositeTaskId.slice(separatorIndex + 1);
        if (taskId && /^\d{13}$/.test(operationTimeText)) {
            return {
                task_id: taskId,
                operation_time: Number(operationTimeText),
            };
        }
        const operationTime = Number(task.operation_time);
        if (!task.task_id || !Number.isFinite(operationTime)) {
            return null;
        }
        return {
            task_id: task.task_id,
            operation_time: operationTime,
        };
    }
    deleteTask(task_id) {
        this.confirmLoading = true;
        deleteTaskApi({ task_id })
            .then(() => {
            this.fetchTasks();
        })
            .catch(err => {
            Toast({
                dangerouslyUseHTMLString: true,
                type: 'error',
                message: err._error_msg,
                showClose: true,
            });
        })
            .finally(() => {
            this.confirmLoading = false;
            this.confirmType = '';
        });
    }
    emptyTask() {
        this.confirmLoading = true;
        deleteAllTaskApi()
            .then(() => {
            this.fetchTasks();
        })
            .catch(err => {
            Toast({
                dangerouslyUseHTMLString: true,
                type: 'error',
                message: err._error_msg,
                showClose: true,
            });
        })
            .finally(() => {
            this.confirmLoading = false;
            this.confirmType = '';
        });
    }
    undoTask(task_id) {
        this.confirmLoading = true;
        undoTaskApi({ task_id }).then(res => {
            this.undoInProgress = true;
            this.getUndoTaskStatusById(task_id);
        }).catch(err => {
            Toast({
                dangerouslyUseHTMLString: true,
                type: 'error',
                message: err._error_msg,
                showClose: true,
            });
        }).finally(() => {
            this.confirmLoading = false;
            this.confirmType = '';
        });
    }
    getUndoTaskStatusById(taskId) {
        this.undoInProgressTimeOut = false;
        if (this.pollingTimes > MAX_POLLING_TIME) {
            this.undoInProgressTimeOut = true;
            return;
        }
        // 如果已经取消了，就不再轮询
        if (!this.undoInProgress) {
            return;
        }
        setTimeout(() => {
            this.pollingTimes += POLLING_STEP_TIME;
            if (POLLING_STEP_TIME < MAX_POLLING_STEP_TIME) {
                POLLING_STEP_TIME = POLLING_STEP_TIME * 2;
            }
            getUndoTaskStatusByIdApi({ task_id: taskId }).then(res => {
                if (res === 'FINISHED_STATUS') {
                    this.undoInProgress = false;
                    this.fetchTasks();
                    Toast({
                        dangerouslyUseHTMLString: true,
                        type: 'success',
                        message: this.i18n.t('undoAction.task.success'),
                        showClose: true,
                    });
                }
                else {
                    this.getUndoTaskStatusById(taskId);
                }
            }).catch(err => {
                Toast({
                    dangerouslyUseHTMLString: true,
                    type: 'error',
                    message: err._error_msg,
                    showClose: true,
                });
                this.confirmLoading = false;
                this.confirmType = '';
            });
        }, POLLING_STEP_TIME * 1000);
    }
    /**
     * 点击单条记录进行确认操作
     * @param {*} type
     * @param {*} task
     */
    confirmOperation(type, task = {}) {
        this.confirmType = type;
        this.confirmTask = task;
        this.initConfirmDialogData();
    }
    initConfirmDialogData() {
        let i18nData = {};
        if (this.confirmType !== 'undo') {
            i18nData = _.get(dialogConfig, this.confirmType, {});
        }
        else {
            i18nData = _.get(undoDialogConfig, this.confirmTask.task_type, {});
        }
        this.confirmDialogData = i18nData;
    }
    /**
     * 确认执行
     */
    confirmSubmit() {
        const taskId = _.get(this.confirmTask, 'task_id');
        switch (this.confirmType) {
            case 'delete':
                this.deleteTask(taskId);
                break;
            case 'cancel':
                this.cancelTask(taskId);
                break;
            case 'cancelAiTagging':
                this.cancelAiTaggingTask(this.confirmTask);
                break;
            case 'empty':
                this.emptyTask();
                break;
            case 'undo':
                this.undoTask(taskId);
                break;
        }
        this.rvTrackTaskCenter(this.confirmType);
    }
    rvTrackTaskCenter(type) {
        rvTrack('Execute Task Center Item', {
            type,
        });
    }
    setUndoInProgress(status) {
        this.undoInProgress = status;
    }
};
TaskCenterService = __decorate([
    provide(TaskCenterServiceSymbol)
], TaskCenterService);
export { TaskCenterService };
